
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view'">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-md-5 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-0px font-family"> {{field.Title}}</label>
    </div>
    <!--<div class="col-md-1 font-weight-bold margin-top-5px">
      :
    </div>-->
    <div class="col-md-6 padding-left-0px padding-right-0px">

      <!--<div class="date-form">
        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
               name="dp2" [(ngModel)]="field.Value" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth="ngModel">
        <small class="form-text text-danger"
               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
        <a (click)="d2.toggle()" class="nav-link-hand">
          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

        </a>

      </div>-->
      <label class="margin-bottom-0px font-weight-normal font-family">{{field.Value |date:'MMM-dd-yyyy'}}</label>

    </div>

  </div>

</div>



